import { useQuery } from '@apollo/client';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import ChevronDownSvg from 'images/v5/icons/chevron-down.svg';
import Button from 'layout/atoms/Button/Button';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Loader from 'layout/atoms/Loader/Loader';
import { fetchCurrencies, selectCurrencies, selectCurrenciesErrors, selectCurrenciesStatus, } from 'store/parameters/currenciesSlice';
function CurrencySelect({ size = 's', value, name, price, disabled = false, useDefaultCurrencyFallback = false, error = false, onChange, }) {
    var _a, _b;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { data: tenantData } = useQuery(GET_CURRENT_TENANT, {
        skip: !useDefaultCurrencyFallback,
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
    });
    const [inputValue, setInputValue] = useState(value);
    const defaultCurrencyAppliedRef = useRef(false);
    const currencies = useSelector(selectCurrencies);
    const status = useSelector(selectCurrenciesStatus).fetch;
    const errors = useSelector(selectCurrenciesErrors).fetch;
    const defaultCurrency = (_b = (_a = tenantData === null || tenantData === void 0 ? void 0 : tenantData.me) === null || _a === void 0 ? void 0 : _a.currentTenant) === null || _b === void 0 ? void 0 : _b.defaultCurrency;
    const selectedIsoCode = value || (useDefaultCurrencyFallback ? (defaultCurrency === null || defaultCurrency === void 0 ? void 0 : defaultCurrency.isoCode) || '' : value);
    const displayValue = selectedIsoCode;
    useEffect(() => {
        setInputValue(displayValue);
    }, [displayValue]);
    useEffect(() => {
        if (value) {
            defaultCurrencyAppliedRef.current = false;
            return;
        }
        if (!useDefaultCurrencyFallback || !(defaultCurrency === null || defaultCurrency === void 0 ? void 0 : defaultCurrency.id) || defaultCurrencyAppliedRef.current) {
            return;
        }
        defaultCurrencyAppliedRef.current = true;
        onChange(defaultCurrency.id, defaultCurrency.isoCode, name, price);
    }, [
        defaultCurrency === null || defaultCurrency === void 0 ? void 0 : defaultCurrency.id,
        defaultCurrency === null || defaultCurrency === void 0 ? void 0 : defaultCurrency.isoCode,
        name,
        onChange,
        price,
        useDefaultCurrencyFallback,
        value,
    ]);
    const fetchCurrenciesOnOpen = () => {
        if (disabled) {
            return;
        }
        if (status === 'idle') {
            dispatch(fetchCurrencies());
        }
    };
    const handleChange = (id, isoCode, name, price) => {
        onChange(id, isoCode, name, price);
    };
    return (React.createElement(Dropdown, { trigger: React.createElement(Button, { size: size, theme: "border", color: error ? 'danger' : 'secondary', rightIcon: React.createElement(ChevronDownSvg, null), disabled: disabled }, inputValue ? inputValue.toUpperCase() : t('common:currency')), onOpen: fetchCurrenciesOnOpen },
        (status === 'loading' || status === ' idle') && React.createElement(Loader, { size: "m" }),
        !errors
            ? currencies.map((currency) => (React.createElement(Button, { key: currency.id, align: "left", theme: currency.isoCode === selectedIsoCode ? 'fill' : 'ghost', disabled: disabled, onClick: () => handleChange(currency.id, currency.isoCode, name, price) }, currency.isoCode.toUpperCase())))
            : t('no_results_header')));
}
export default CurrencySelect;
